/**
 * 
 * @author 
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

import axios from "axios";
import ServicePath from "@/core/ServicePath";
import {
    MainRequest
} from "@/core/request";

export default class RolePermissionRequest extends MainRequest {

    static listAllRoles() {
        return this.getSEC(ServicePath.ROLE_ALL);
    }

    static getStudy(data) {
        return this.postSEC(ServicePath.STUDY_BY_ID, data)
    }

    static getPermissionsByRol(data) {
        return this.postSEC(ServicePath.ROLE_PERMISSION_LIST_ALL, data)
    }

    static getPermissions() {
        return this.getSEC(ServicePath.PERMISSIONS_LIST_ALL)
    }

    static addRolePermission(data) {
        return this.postSEC(ServicePath.ROLE_PERMISSION_ADD, data)
    }

    static removeRolePermission(data) {
        return this.postSEC(ServicePath.ROLE_PERMISSION_DELETE, data)
    }

    static statusRole(data) {
        return this.postSEC(ServicePath.ROLE_STATUS, data)
    }

    static addRole(data) {
        return this.postSEC(ServicePath.ROLE_ADD, data)
    }

    static save(data) {
        return this.postSEC(ServicePath.ROLE_PERMISSION_SAVE, data)
    }

    static duplicateRole(data) {
        return this.postSEC(ServicePath.ROLE_PERMISSION_DUPLICATE, data)
    }

}